import {IconSizeProps} from "./types";

export default function TonLightIcon({size = 40, ...props}: IconSizeProps) {
    return (
        <svg width={size} height={size} {...props} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"
             xmlnsXlink="http://www.w3.org/1999/xlink">
            <path stroke="null" id="svg_2" fill="white"
                  d="m28.551235,7.336842l-17.103441,0c-3.144714,0 -5.137911,3.392209 -3.555804,6.134509l10.555606,18.295835c0.688817,1.19463 2.41502,1.19463 3.103838,0l10.557753,-18.295835c1.57996,-2.737917 -0.413237,-6.134509 -3.555804,-6.134509l-0.002147,0zm-10.112226,18.943687l-2.298831,-4.449093l-5.546854,-9.920635c-0.36592,-0.634971 0.086046,-1.448654 0.852323,-1.448654l6.991215,0l0,15.820529l0.002147,-0.002147zm10.962403,-14.371875l-5.544707,9.924928l-2.298831,4.446947l0,-15.820529l6.991215,0c0.766277,0 1.218244,0.813683 0.852323,1.448654z"/>
        </svg>

    )
}